import styled from "styled-components";
import ToggleButton from "@8x8/oxygen-toggle-button";

const StyledToggleButton = styled(ToggleButton).attrs()`
  & label {
    margin-bottom: 0;
    margin-right: 4px;
  }

  background-color: ${(props) => (props.hasError ? "red" : "")};
`;

export default StyledToggleButton;
